module.exports = __webpack_public_path__ + "img/tick-unread.5f37c067.svg";